import { useCallback, useState } from 'react';
import type { BillingSubmissionSummary } from './billingDashboardTypes';
import { getAuthHeaders } from './billingDashboardUtils';

export function useBillingSubmissions(workItemId?: string) {
  const [billingSubmissions, setBillingSubmissions] = useState<BillingSubmissionSummary[]>([]);
  const [billingSubmissionsLoading, setBillingSubmissionsLoading] = useState(false);

  const loadBillingSubmissions = useCallback(async () => {
    if (!workItemId) {
      setBillingSubmissions([]);
      return;
    }
    setBillingSubmissionsLoading(true);
    try {
      const res = await fetch(`/api/v1/work-items/${workItemId}/billing-submission?scope=all`, {
        headers: getAuthHeaders(),
      });
      const json = await res.json().catch(() => null) as {
        success?: boolean;
        data?: BillingSubmissionSummary[] | null;
      };
      if (res.ok && json.success && Array.isArray(json.data)) {
        setBillingSubmissions(json.data);
      } else {
        setBillingSubmissions([]);
      }
    } catch {
      setBillingSubmissions([]);
    } finally {
      setBillingSubmissionsLoading(false);
    }
  }, [workItemId]);

  return {
    billingSubmissions,
    billingSubmissionsLoading,
    loadBillingSubmissions,
  };
}
